import { HostEventValidationConfig } from '@thoughtspot/embed-util';

let parentOrigin: string = null;

// Default: shouldBypassPayloadValidation is undefined so that
// shouldBypassValidation() can use V2-based default logic
let hostEventConfig: HostEventValidationConfig = {
    shouldBypassPayloadValidation: undefined,
    useHostEventsV2: false,
};

export const setParentOrigin = (origin: string, protocol?: string) => {
    const fallback =
        window.location !== window.parent.location
            ? document.referrer
            : document.location.href;

    const fallbackProtocol = document.referrer.split('://')[0];
    let resolvedProtocol = protocol?.toLowerCase() || fallbackProtocol;

    if (!['http', 'https'].includes(resolvedProtocol)) {
        resolvedProtocol = 'https';
    }

    const sdkOrigin =
        origin && origin !== 'local-host'
            ? `${resolvedProtocol}://${origin}`
            : null;

    parentOrigin = origin === 'local-host' ? '*' : sdkOrigin || fallback || '*';
};

export const getParentOrigin = () => parentOrigin;

export const computeHash = (data: any) =>
    typeof data === 'object' ? JSON.stringify(data) : String(data);

export const setHostEventConfig = (
    config: Partial<HostEventValidationConfig>,
) => {
    hostEventConfig = { ...hostEventConfig, ...config };
};

export const getHostEventConfig = () => hostEventConfig;
